<div class="p-3">
    <div class="container">
    <h1 class="display-5 mb-4">{{ 'Project.SelectProvider' | translate:locale.language }}</h1>
        <form action="your-action" (submit)="onFormSubmit($event)">
            <div class="row">
                <div class="col-sm-6 mb-3">
                    <dx-drop-down-box
                            [(value)]="selectedProviders"
                            [opened]="false"
                            valueExpr="id"
                            displayExpr="name"
                            placeholder="Select a value..."
                            [showClearButton]="true"
                            [dataSource]="providersDataSource"
                            (onInitialized)="initDropDown($event)"
                        >
    
                        <div *dxTemplate="let data of 'content'">
                            <dx-data-grid
                                    [dataSource]="providersDataSource"
                                    [(selection)]="selectionMode"
                                    [hoverStateEnabled]="true"
                                    [paging]="{ enabled: true, pageSize: 10 }"
                                    [filterRow]="{ visible: true }"
                                    [scrolling]="{ mode: 'infinite' }"
                                    [height]="345"
                                    [(selectedRowKeys)]="selectedProviders"
                                    (onInitialized)="initGrid($event)"
                            >
                                <dxi-column dataField="name" caption= "{{ 'Project.Provider' | translate:locale.language }}" dataType="string">
                                </dxi-column>
                                <dxi-column dataField="postalCode" caption= "{{ 'Project.PostalCode' | translate:locale.language }}" dataType="string">
                                </dxi-column>
                                <dxi-column dataField="city" caption= "{{ 'Project.City' | translate:locale.language }}" dataType="string">
                                </dxi-column>
                            </dx-data-grid>
                        </div>
                    </dx-drop-down-box>
                </div>
                <div class="col-sm-6 mb-3">
                    <button type="submit" class="btn btn-primary">
                        {{ 'Core.EditSave' | translate:locale.language }}
                    </button>
                </div>
            </div>
         </form>
        <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error | translate:locale.language}}</div>
    
        <div  *ngIf="hcProviderLinks.length" class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4">
            <div class="col" *ngFor="let item of hcProviderLinks">
                <div class="card mb-3 h-100">
                    <h4 class="card-header">{{item.healthcareProvider.name}}</h4>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6 mb-3">
                                {{item.healthcareProvider.postalCode}} <br>
                                {{item.healthcareProvider.city}} <br>
                                {{item.healthcareProvider.address}} <br>
                                
                            </div>
                            <div class="col-sm-6 mb-3">
                                <a href="{{item.healthcareProvider.webUrl}}" target="_blank">{{ 'Project.WebUrl' | translate:locale.language }}</a> <br>
                                <a href="{{item.healthcareProvider.mapLink}}" target="_blank">{{ 'Project.MapLink' | translate:locale.language }}</a> <br>
                                <a href="mailto:{{item.healthcareProvider.email}}" target="_blank">{{item.healthcareProvider.email}}</a> <br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col mb-3">
                                <textarea class="form-control" rows="5">{{item.healthcareProvider.openingHours}}</textarea>
                            </div>
                        </div>
                        <div *ngIf="!doctorUser" class="row">
                            <div class="dx-field">
                                <div class="dx-field-label">{{ 'Project.SelectDoctor' | translate:locale.language }}</div>
                                <div class="dx-field-value">
                                    <dx-select-box [dataSource]="doctorSource"
                                                valueExpr="id"
                                                displayExpr="userName"
                                                (onValueChanged)="onDoctorChanged($event)"
                                                [(value)]="selectedDoctor">
                                        <dx-validator>
                                            <dxi-validation-rule type="required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


